export const navLinks = [
  { navLinkKey: "menu.home", scrollToId: "homeContainer" },
  { navLinkKey: "menu.team", scrollToId: "teamContainer" },
  { navLinkKey: "menu.about", scrollToId: "aboutContainer" },
  { navLinkKey: "menu.offering", scrollToId: "offeringContainer" },
  { navLinkKey: "menu.contacts", scrollToId: "contactContainer" },
];
